import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import settingicon from '../assets/settings.png';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import ReplayIcon from '@mui/icons-material/Replay';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import EmpModal from '../tables/Modals/EmpModal';
import tractorfill from '../assets/ph_tractor-fill.svg'
import EcpModal from '../tables/Modals/EcpModal';
import { useSelector } from 'react-redux';
import { timesheetcalendericon } from '../utils/svgs/svgs';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
const MainDashboardFilters = ({ counts,isoldbuild,setOldbuild,activeFilter,isDecimal, setIsDecimalMode,tab,
  setEditedRows,setActiveFilter,fetchdata,group_by,setSelectedRows, isDateRangeOpen, setIsDateRangeOpen,selectedDate,setSelectedDate, setAlertMessage, setSeverity, setOpen  }) => {
  const [empModal,setEmpModal]=useState(false);
  const [ecpModal,setEcpModal]=useState(false);
    const navigate=useNavigate()
    const datePickerRef = useRef(null);
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const filterMenuRef = useRef(null);
      const [selectedFilters, setSelectedFilters] = useState(['EQP','EMP']);
const user = useSelector((state) => state.user.userDetails);

const toggleFilter = (value) => {
  setSelectedFilters((prev) =>
    prev.includes(value)
      ? prev.filter((item) => item !== value) // remove if already selected
      : [...prev, value]                      // add if not selected
  );
};

const handleApply = () => {
  const hasEMP = selectedFilters.includes('EMP');
  const hasEQP = selectedFilters.includes('EQP');

  if (hasEMP && hasEQP) {
    setActiveFilter({ label: "All", value: "total_count", count: 0 });
  } else if (hasEMP) {
    setActiveFilter('EMP');
  } else if (hasEQP) {
    setActiveFilter('EQP');
  } else {
    setActiveFilter({ label: "All", value: "total_count", count: 0 });
  }

  setFilterMenuOpen(false);
};


  const handleReset = () => {
    setSelectedFilters(['EQP','EMP']);
    setActiveFilter({label:"All",value:"total_count",count:0})
    setSelectedRows([])
    setFilterMenuOpen(false)
  };
    // Close date picker when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
                setIsDateRangeOpen(false);
            }
        }

        if (isDateRangeOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDateRangeOpen]);
const goToPreviousDate = () => {
    setSelectedDate((prev) => new Date(prev.setDate(prev.getDate() - 1)));
  };

  const goToNextDate = () => {
    setSelectedDate((prev) => new Date(prev.setDate(prev.getDate() + 1)));
  };

    useEffect(() => {
        function handleMenuClickOutside(event) {
          if (filterMenuRef.current && !filterMenuRef.current.contains(event.target)) {
            setFilterMenuOpen(false);
          }
        }
      
        if (filterMenuOpen) {
          document.addEventListener("mousedown", handleMenuClickOutside);
        }
      
        return () => {
          document.removeEventListener("mousedown", handleMenuClickOutside);
        };
      }, [filterMenuOpen]);
      

    return (
        <div className="flex flex-wrap items-center justify-between p-4 gap-4">
            {/* Left Side: Arrow Icon and Filter Buttons */}
            <div className="flex flex-wrap items-center gap-4">
                {/* Left Arrow Icon */}
                <div className="p-2 bg-[#F3F4F6] rounded-md">
                    <FontAwesomeIcon icon={faArrowLeft} onClick={()=>
                      {
                        setEditedRows({})
                        navigate(-1)}} className="text-xl cursor-pointer text-black" />
                </div>

                {/* Filter Buttons */}
                <div className="flex flex-wrap gap-2">
                    {counts.map((label, count) => (
                        <button
                            key={label.label}
                            onClick={() =>{setActiveFilter(label);
                              setSelectedRows([])}}
                            className={`min-w-[80px] px-4 py-2 rounded-md transition-colors duration-200 ${
                                activeFilter.label === label.label ? 'bg-[#900] text-white' : 'bg-[#F3F4F6] text-black'
                            }`}
                        >
                            {label.label} ({label.count})
                        </button>
                    ))}
                </div>
          

            </div>
               {/* <div className="flex items-center gap-2 my-2 text-xs font-bold ">
     {isoldbuild? "Switch to Old App" : "Switch to New App"}
      <button
        onClick={() =>setOldbuild(!isoldbuild)}
        className={`relative inline-flex h-4 w-8 items-center rounded-full transition ${
        isoldbuild? "bg-blue-600" : "bg-gray-400"
        }`}
      >
        <span
          className={`inline-block h-3 w-3 transform rounded-full bg-white shadow transition ${
          isoldbuild ? "translate-x-4" : "translate-x-1"
          }`}
        />
      </button>
    </div> */}

            {/* Right Side: Submit Timesheet Button, Date, and Settings Icon */}
            <div className="flex flex-wrap items-center gap-4 relative">
                <div className="flex items-center gap-2 my-2 text-xs font-bold ">
     {isDecimal ? "Switch to HH:MM" : "Switch to Decimal"}
      <button
        onClick={() => setIsDecimalMode(!isDecimal)}
        className={`relative inline-flex h-4 w-8 items-center rounded-full transition ${
          isDecimal ? "bg-blue-600" : "bg-gray-400"
        }`}
      >
        <span
          className={`inline-block h-3 w-3 transform rounded-full bg-white shadow transition ${
            isDecimal ? "translate-x-4" : "translate-x-1"
          }`}
        />
      </button>
    </div>
            {tab==='emp'?<div
  onClick={() => {
    if (user?.user_roles?.role !== 'Project Manager') {
      setEmpModal(true);
    }
  }}
  className={`${
    user?.user_roles?.role === 'Project Manager' ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
  }`}
>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M11 3.75C10.0054 3.75 9.05161 4.14509 8.34835 4.84835C7.64509 5.55161 7.25 6.50544 7.25 7.5C7.25 8.49456 7.64509 9.44839 8.34835 10.1517C9.05161 10.8549 10.0054 11.25 11 11.25C11.9946 11.25 12.9484 10.8549 13.6517 10.1517C14.3549 9.44839 14.75 8.49456 14.75 7.5C14.75 6.50544 14.3549 5.55161 13.6517 4.84835C12.9484 4.14509 11.9946 3.75 11 3.75ZM7 13.25C6.00544 13.25 5.05161 13.6451 4.34835 14.3483C3.64509 15.0516 3.25 16.0054 3.25 17V18.188C3.25 18.942 3.796 19.584 4.54 19.705C8.818 20.404 13.182 20.404 17.46 19.705C17.8198 19.6458 18.147 19.4608 18.3832 19.1831C18.6194 18.9053 18.7494 18.5527 18.75 18.188V17C18.75 16.0054 18.3549 15.0516 17.6517 14.3483C16.9484 13.6451 15.9946 13.25 15 13.25H14.66C14.4733 13.2507 14.292 13.2793 14.116 13.336L13.25 13.619C11.788 14.0963 10.212 14.0963 8.75 13.619L7.884 13.336C7.70847 13.2797 7.52534 13.2507 7.341 13.25H7ZM19.5 6.25C19.6989 6.25 19.8897 6.32902 20.0303 6.46967C20.171 6.61032 20.25 6.80109 20.25 7V8.75H22C22.1989 8.75 22.3897 8.82902 22.5303 8.96967C22.671 9.11032 22.75 9.30109 22.75 9.5C22.75 9.69891 22.671 9.88968 22.5303 10.0303C22.3897 10.171 22.1989 10.25 22 10.25H20.25V12C20.25 12.1989 20.171 12.3897 20.0303 12.5303C19.8897 12.671 19.6989 12.75 19.5 12.75C19.3011 12.75 19.1103 12.671 18.9697 12.5303C18.829 12.3897 18.75 12.1989 18.75 12V10.25H17C16.8011 10.25 16.6103 10.171 16.4697 10.0303C16.329 9.88968 16.25 9.69891 16.25 9.5C16.25 9.30109 16.329 9.11032 16.4697 8.96967C16.6103 8.82902 16.8011 8.75 17 8.75H18.75V7C18.75 6.80109 18.829 6.61032 18.9697 6.46967C19.1103 6.32902 19.3011 6.25 19.5 6.25Z"
      fill="black"
    />
  </svg>
</div>:<></>}

             <div
  onClick={() => {
    if (user?.user_roles?.role !== 'Project Manager') {
      setEcpModal(true);
    }
  }}
  className={`px-3 relative rounded py-[2px] ${
    user?.user_roles?.role === 'Project Manager' ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
  }`}
>
  <div><img src={tractorfill} alt="" /></div>
  <div className='absolute top-0 right-0'>
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M7 3.5V10.5M3.5 7H10.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>
</div>

                <div className='cursor-pointer px-3 rounded py-[2px] ' onClick={() => window.location.reload()}>
                <ReplayIcon className='text-gblack' />
                </div>

                <div
  className="inline-flex items-center justify-center gap-2 h-10 px-4 py-2 rounded-[6px] border border-[#E4E4E7] bg-white text-black"
  style={{ minWidth: 'fit-content' }}
>
  {/* Previous Date Button */}
  <button onClick={goToPreviousDate} className="p-1 hover:bg-gray-100 rounded flex items-center justify-center">
    <FiChevronLeft size={20} />
  </button>

  {/* Date Picker Trigger */}
  <div
    onClick={() => setIsDateRangeOpen(!isDateRangeOpen)}
    className="flex items-center gap-2 cursor-pointer select-none"
  >
    <span className="flex items-center justify-center">
      {timesheetcalendericon}
    </span>
    <span className="text-sm font-medium">
      {selectedDate.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      })}
    </span>
  </div>

  {/* Next Date Button */}
  <button onClick={goToNextDate} className="p-1 hover:bg-gray-100 rounded flex items-center justify-center">
    <FiChevronRight size={20} />
  </button>
</div>

                
                {isDateRangeOpen && (
                    <div ref={datePickerRef} className="absolute z-40 top-12 right-0 bg-white p-4 shadow-lg rounded-md border z-10">
                        <DatePicker 
                            selected={selectedDate} 
                            onChange={(date) => {
                                setSelectedDate(date);
                                setIsDateRangeOpen(false); // Close the modal after selecting date
                            }} 
                            inline 
                        />
                    </div>
                )}
      {/* <div className="relative z-60" ref={filterMenuRef}>
  <div
    onClick={() => setFilterMenuOpen(!filterMenuOpen)}
    className="px-3 cursor-pointer rounded py-[2px] "
  >
    <FilterAltIcon className="text-black" />
  </div>

  {filterMenuOpen && (
<div
  className="absolute z-50 mt-1 right-4 bg-white border border-gray-200 rounded-md shadow-lg p-4 flex flex-col items-start gap-4 w-[240px]"
>
  <div className="flex flex-col gap-2 w-full">
    <label className="flex items-center justify-between w-full text-sm text-black">
      <div className="flex items-center gap-2">
        <input
          type="checkbox"
       checked={selectedFilters.includes('EMP')}
          onChange={() => toggleFilter('EMP')}
          className="form-checkbox accent-black"
        />
        <span>Employee</span>
      </div>
      <span className={`text-sm cursor-pointer ${selectedFilters.includes('EMP')?'text-black':"text-gray-500"} `}>Only</span>
    </label>

    <label className="flex items-center justify-between w-full text-sm text-black">
      <div className="flex items-center gap-2">
        <input
          type="checkbox"
           checked={selectedFilters.includes('EQP')}
          onChange={() => toggleFilter('EQP')}
          className="form-checkbox accent-black"
        />
        <span>Equipment</span>
      </div>
      <span className={`text-sm cursor-pointer ${selectedFilters.includes('EQP')?'text-black':"text-gray-500"} `}>Only</span>
    </label>
  </div>

  <div className="flex gap-2 w-full">
    <button
      onClick={handleReset}
      className="flex-1 rounded border border-black bg-white text-black text-sm py-1"
    >
      Reset
    </button>

    <button
      onClick={handleApply}
      className="flex-1 rounded bg-black text-white text-sm py-1"
    >
      Apply
    </button>
  </div>
</div>



    // <div className="absolute z-10 mt-1 left-0 bg-white border border-gray-200 rounded-md shadow-lg w-20">
    //   <button
    //     onClick={() => {
    //       setActiveFilter('EMP')
    //       setFilterMenuOpen(false);
    //     }}
    //     className="w-full text-left px-4 py-2  text-sm hover:bg-gray-100"
    //   >
    //     EMP
    //   </button>
    //   <button
    //     onClick={() => {
    //       setActiveFilter('EQP')
    //       setFilterMenuOpen(false);
    //     }}
    //     className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
    //   >
    //     EQP
    //   </button>
    // </div>
  )}
</div> */}

 {empModal && <EmpModal  
  previousdate={selectedDate}
 fetchdata={fetchdata}
 setOpen={setOpen}
 setAlertMessage={setAlertMessage}
 setSeverity={setSeverity}
 group_by={group_by}  setEmpModal={setEmpModal} />}
 {ecpModal && <EcpModal 
 previousdate={selectedDate}
 setOpen={setOpen}
 setAlertMessage={setAlertMessage}
  fetchdata={fetchdata}
 setSeverity={setSeverity} setEcpModal={setEcpModal} />}
                {/* <img src={settingicon} alt="settings" className="w-6 h-6" /> */}
            </div>
        </div>
    );
};

export default MainDashboardFilters;
